import { useDispatch, useSelector } from "react-redux";
import {
  filterVideoLibraryDataTable,
  saveTable,
  setIsTableEditable,
} from "../../../../Redux/Actions/VideoLibraryDataTableActions";
import ManageColumnSet from "../ManageColumns/ManageColumnSet";
import * as Icons from "@mui/icons-material";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import HoverToolTip from "../../../../Common/ToolTips/HoverToolTips/HoverToolTip";
import {
  setFilterValues,
  updateFilter,
  addNewFilter,
} from "../../../../Redux/Actions/VideoLibraryFilterAction";
import { setEditFilter } from "../../../../Redux/Actions/VideoLibraryFilterAction";
import { setEditFilterInformation } from "../../../../Redux/Actions/VideoLibraryFilterAction";
import { openAddFilterPopup } from "../../../../Redux/Actions/VideoLibraryFilterAction";
import AddNewFilterDialog from "../../Popups/AddNewFilterDialog";
import Tabs from "../../../Tabs/Tabs";
import CurrentFilter from "./Filter/CurrentFilter";
import QuickFilter from "./Filter/QuickFilter";
import style from "./table.module.css";
import { useEffect, useState } from "react";

const TableHeader = ({
  fetchBreakDownDetails,
  videoSettings,
  setVideoSettings,
  handleZoomIn,
  handleZoomOut,
}) => {
  const dispatch = useDispatch();
  const schoolId = getFromLocalStorage("schoolId");
  const currentUserId = getFromLocalStorage("currentUserId");
  const { ArrowDropUp: ArrowDropUpIcon, ArrowDropDown: ArrowDropDownIcon } =
    Icons;
  const { filteredTableData, tableData, tableSeasonInfo } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  const { filterValues, addFilterPopUp: addPopUp } = useSelector(
    (state) => state?.videoLibraryFilterData
  );
  const { selectedColumnSet, selectedPlaylist } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  const { socket } = useSelector((state) => state?.SocketData);
  const [openSecondFilter, setOpenSecondFilter] = useState(false);

  const handleRemoveAllFilter = () => {
    filterVideoLibraryDataTable(dispatch, []);
    setFilterValues(dispatch, []);
  };

  const updateFilterPost = (
    { filterName, breakDownName, conditionName, conditionValue },
    filterId
  ) => {
    updateFilter(dispatch, {
      filterName,
      breakDownName,
      conditionName,
      conditionValue,
      filterId,
      schoolId,
    });
  };

  const addFilter = ({
    filterName,
    breakDownName,
    conditionName,
    conditionValue,
  }) => {
    addNewFilter(dispatch, {
      filterName,
      breakDownName,
      conditionName,
      conditionValue,
      schoolId,
    });
  };

  const toggleAddPopUpDialog = (status) => {
    setEditFilter(dispatch, false);
    setEditFilterInformation(dispatch, null);
    openAddFilterPopup(dispatch, { status: status });
  };
  return (
    <>
      {tableData && (
        <div className="bottomHeader position-relative">
          <div className="d-flex-space-between d-flex-wrap-m">
            <div className="d-flex align-items-center gap-10 d-flex-wrap-m">
              <p className={`fs-16 semi-bold ${style.clipText}`}>
                Clips{" "}
                {filteredTableData?.length
                  ? filteredTableData?.length
                  : tableData?.length}{" "}
                Of {tableData?.length}
              </p>
              <ManageColumnSet
                fetchBreakDownDetails={fetchBreakDownDetails}
                schoolId={schoolId}
              />
              <HoverToolTip
                content={
                  <div className="position-relative">
                    <Tabs defaultActiveTab={0}>
                      <QuickFilter label="Quick Filter" />
                      <CurrentFilter label="Current Filter" />
                    </Tabs>
                  </div>
                }
                variant="medium"
                showToolTip={true}
                trigger={"click"}
              >
                <button
                  className="small-btn fs-16"
                  onClick={() => setOpenSecondFilter(true)}
                >
                  Filters
                </button>
              </HoverToolTip>

              <button className="small-btn fs-16">
                <span>{filterValues?.length} </span>
                <span className={style.divider}></span>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveAllFilter();
                  }}
                >
                  {" "}
                  &times;
                </span>
              </button>
              <button className="small-btn fs-16" onClick={handleZoomIn}>
                Zoom In
              </button>
              <h3 className="fs-24 bold">
                Column Set : {selectedColumnSet?.columnName}
              </h3>
            </div>
            <div className="d-flex align-items-center gap-10 d-flex-wrap-m">
              <button className="small-btn fs-16" onClick={handleZoomOut}>
                Zoom Out
              </button>
              <button
                className="small-btn fs-16"
                onClick={() =>
                  saveTable(dispatch, {
                    selectedColumnSet,
                    tableData,
                    schoolId,
                    table:
                      filteredTableData?.length > 0
                        ? "filteredTableData"
                        : "tableData",
                    filteredTableData,
                    scheduleId: tableSeasonInfo?.scheduleId,
                    currentUserId,
                  })
                }
              >
                Save Playlist
              </button>
            </div>
          </div>
          <div
            onClick={() =>
              setVideoSettings((prevState) => ({
                ...prevState,
                fullHeight: !prevState.fullHeight,
              }))
            }
          >
            {videoSettings.fullHeight ? (
              <ArrowDropDownIcon className="icon-btn cp hover-scale" />
            ) : (
              <ArrowDropUpIcon className="icon-btn cp hover-scale" />
            )}
          </div>
        </div>
      )}
      <AddNewFilterDialog
        successPopUp={addPopUp}
        toggleAddPopUpDialog={toggleAddPopUpDialog}
        addFilter={addFilter}
        updateFilter={updateFilterPost}
      />
    </>
  );
};

export default TableHeader;
